import { render, staticRenderFns } from "./company-details.component.vue?vue&type=template&id=b34b1590&scoped=true&"
import script from "./company-details.component.ts?vue&type=script&lang=ts&"
export * from "./company-details.component.ts?vue&type=script&lang=ts&"
import style0 from "./company-details.component.scss?vue&type=style&index=0&id=b34b1590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34b1590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
